import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { TermsAndPrivacyLinks } from '@hcs/auth';
import { Card, LoadingSpinner } from '@hcs/design-system';
import { APP_CONFIG_PEXP, APP_CONFIG_PLATFORM } from '@hcs/hc-products';
import {
  SelfServiceSetupCreditCard,
  useUserSelfServiceConfirmed,
} from '@hcs/self-service';

import styles from './PexpSelfServiceSetupPage.module.css';

const dataHcName = 'pexp-self-setup-page';
export const PexpSelfServiceSetupPage = () => {
  const navigate = useNavigate();
  const { data: isUserConfirmed, isInitialLoading } =
    useUserSelfServiceConfirmed({
      checkPaymentIntent: true,
    });
  useEffect(() => {
    if (isUserConfirmed) {
      navigate(APP_CONFIG_PLATFORM.rootPath);
    }
  }, [isUserConfirmed, navigate]);

  return (
    <>
      <Card
        dataHcEventSection="Self Serve Credit Card Entry"
        dataHcName={dataHcName}
        className={styles.Card}
      >
        {isInitialLoading ? (
          <LoadingSpinner dataHcName={`${dataHcName}-loading-spinner`} />
        ) : (
          <SelfServiceSetupCreditCard
            onGetStarted={() => navigate(APP_CONFIG_PEXP.rootPath)}
          />
        )}
      </Card>
      <TermsAndPrivacyLinks />
    </>
  );
};
